import classNames from "classnames";
import { FormField } from "./FormField";
import { FormStepSubGroupType } from "@/data/forms/types";
import { useFormUtils } from "@/hooks/useFormUtils";
import { useEffect } from "react";

export const FormSubGroup = ({
  subGroup,
  t,
  formMethods,
}: {
  subGroup: FormStepSubGroupType;
  t: Record<string, string>;
  formMethods: any;
}) => {
  const { isSubGroupVisible } = useFormUtils();
  const subGroupClassnames = classNames("subgroup", {
    [`subgroup--${subGroup.name}`]: subGroup.name,
    "u-grid-col-12": subGroup.uniqueRow || !subGroup.cols,
    [`u-grid-col-${subGroup.cols}`]: subGroup.cols,
  });
  const { values, setValue } = formMethods;

  useEffect(() => {
    subGroup.fields.forEach((field: any) => {
      if (!isSubGroupVisible(field, values) && values[field.name]) {
        setValue(field.name, "");
      }
    });
  }, [values, subGroup.fields, isSubGroupVisible, setValue]);

  return (
    <div className={subGroupClassnames}>
      <p className="subgroup-title">{t[subGroup.title]}</p>
      {subGroup.fields.map((field: any) =>
        isSubGroupVisible(field, values) ? (
          <FormField
            key={field.name}
            field={field}
            t={t}
            {...formMethods}
          />
        ) : null
      )}
    </div>
  );
};
